import { Box, Button, Text, styled } from '@ltvco/refresh-lib/theme';

export const OverviewPanel = styled(Box)(({ theme }) => ({
  borderRadius: '8px',
  padding: theme.spacing(2.5),
  backgroundColor: theme.palette.common.white,
  boxShadow: '0 0 0 1px #e0e0e0',
  marginBottom: theme.spacing(3),
}));

export const DateUpdatedRow = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  gap: theme.spacing(1),
  marginBottom: theme.spacing(2.5),
}));

export const DateUpdatedText = styled(Text)(({ theme }) => ({
  fontSize: 14,
  fontWeight: 400,
  lineHeight: '16px',
  color: theme.palette.text.primary,
}));

export const HeroCaseTitle = styled(Text)(({ theme }) => ({
  fontSize: 30,
  fontWeight: 700,
  lineHeight: '36px',
  color: theme.palette.text.primary,
}));

export const AtAGlanceShell = styled(Box)(({ theme }) => ({
  borderRadius: '8px',
  padding: theme.spacing(1.5),
  backgroundColor:
    theme.palette.mode === 'light'
      ? theme.palette.grey[50]
      : theme.palette.grey[900],
}));

export const ClaimCtaButton = styled(Button)(({ theme }) => ({
  flexShrink: 0,
  alignSelf: 'flex-start',
  width: 'auto',
  textTransform: 'none',
  fontWeight: 700,
  borderRadius: 32,
  padding: '8px 22px',
  fontSize: 15,
  lineHeight: '26px',
  letterSpacing: '0.46px',
  [theme.breakpoints.down('sm')]: {
    alignSelf: 'stretch',
    width: '100%',
  },
}));

export const AtAGlanceTitle = styled(Text)(({ theme }) => ({
  fontSize: 16,
  fontWeight: 700,
  lineHeight: '24px',
  color: theme.palette.text.primary,
  marginBottom: theme.spacing(1.5),
}));

export const AiDisclaimer = styled(Text)(({ theme }) => ({
  fontSize: 12,
  fontWeight: 400,
  lineHeight: 1.5,
  color: theme.palette.text.secondary,
  marginTop: theme.spacing(2),
  textAlign: 'left',
}));
